import * as React from "react";

import styles from "./LoginForm.module.scss";
import { LogoContainer } from "../LogoContainer"
import { ActionLink } from "../ActionLink"
import TextInput from "../TextInput"
import { Submit } from "../Submit"
import useLogin from "../../hooks/useLogin";
import World from "../../world";
import { Facebook } from "../OIDC";

type Props = {
    world: World;
    onLoginSuccess?: () => void;
}

export const LoginForm = (props: Props) => {
    const { onChange, onSubmit, isPending, error } = useLogin(props.world, props.onLoginSuccess);

    return (
        <div className={styles["login-form"]}>
            <LogoContainer />

            {error && (
                <p><span className="form-error">{error.message}</span></p>
            )}

            <ActionLink secondary to="/dashboard/create-account">
                No Account? Sign Up
            </ActionLink>

            <form onSubmit={onSubmit}>
                <TextInput
                    name="email"
                    onChange={onChange}
                    placeholder="email"
                    help="Enter Your Email" />

                <TextInput
                    name="password"
                    type="password"
                    onChange={onChange}
                    placeholder="password"
                    help="Enter Your Password " />

                <p>
                    <ActionLink to="/dashboard/reset-password">
                        Reset Password
                    </ActionLink>
                </p>

                <Submit label="Log In" is_pending={isPending} />
            </form>
			<br />
			<hr style={{color: "#eeeeee" }} />
			<br />
			<Facebook />
        </div>
    );
};

export default LoginForm;
